'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgDownload(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.995 0a.622.622 0 00-.623.61v5.386l.056.829-.269-.369-.68-.737a.544.544 0 00-.411-.184.53.53 0 00-.546.532c0 .156.057.276.17.382l1.821 1.744a.643.643 0 00.482.212c.163 0 .32-.05.482-.212L8.3 6.449a.52.52 0 00.17-.382.53.53 0 00-.546-.532.555.555 0 00-.411.184l-.68.737-.27.369.05-.83V.61A.62.62 0 005.995 0zm-3.21 12h6.407c1.261 0 1.935-.666 1.935-1.92V4.742c0-1.255-.674-1.921-1.935-1.921H7.739v1.354h1.34c.446 0 .694.226.694.701v5.06c0 .483-.248.71-.695.71h-6.18c-.453 0-.694-.227-.694-.71v-5.06c0-.475.24-.701.694-.701h1.354V2.822H2.785c-1.262 0-1.935.666-1.935 1.92v5.337C.85 11.334 1.523 12 2.785 12z", id: "Download__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Download__svg__a" })))));
}

module.exports = SvgDownload;
//# sourceMappingURL=Download.js.map
